import { Injectable } from '@angular/core';

interface OfferPosition {
  id: number;
  name: string;
  amount: number;
  tax: number;
  amountBrutto: number | null;
  externalId: string | null;
  quantity: number | null;
}

interface MwstInfo {
  percentage: number;
  amount: number;
}

export class PriceCalculationUtil {
  public static calculatePrices(positions: OfferPosition[]): {
    totalPriceNetto: number;
    totalPriceBrutto: number;
    mwstGrouped: MwstInfo[];
  } {
    if (!positions || positions.length == 0) {
      let totalPriceNetto = 0;
      let totalPriceBrutto = 0;
      const mwstGrouped: MwstInfo[] = [];

      return { totalPriceNetto, totalPriceBrutto, mwstGrouped };
    }

    let totalPriceNetto = 0;
    let totalPriceBrutto = 0;
    const mwstGrouped: MwstInfo[] = [];

    try {
      const groupedByTax = positions.reduce((acc, position) => {
        acc[position.tax] = acc[position.tax] || [];
        acc[position.tax].push(position);
        return acc;
      }, {} as { [key: number]: OfferPosition[] });

      Object.keys(groupedByTax).forEach((taxRate) => {
        const taxPercentage = parseFloat(taxRate);
        const taxAmount = groupedByTax[taxPercentage].reduce((sum, position) => {
          const netto = position.amount;
          totalPriceNetto += netto;
          const brutto = netto * (1 + taxPercentage / 100);
          totalPriceBrutto += brutto;
          return sum + (brutto - netto);
        }, 0);

        mwstGrouped.push({ percentage: taxPercentage, amount: taxAmount });
      });
    } catch (e) {
      console.log('Caught an error while calculating the price: ', e);
      return { totalPriceNetto: null, totalPriceBrutto: null, mwstGrouped: [] };
    }

    return { totalPriceNetto, totalPriceBrutto, mwstGrouped };
  }
}
